export const environment = {
  production: false,
  rootUrl: 'http://localhost:4200',
  apiUrl: 'http://localhost:4200/api',
  googleMapsApiKey: 'AIzaSyAzMrflz6phvyMStGHhjgrC1TaBlFjV2Tg',
   appInsights: {
     instrumentationKey: 'ea5253e5-dfd1-47b3-b5e9-de05aaf5d9e8'
  }
}
